const ShopSuccessPage = () => {
  return (
    <div className="bg-gray-50 flex items-center justify-center min-h-screen">
      <div className="bg-white p-8 rounded-2xl shadow-lg max-w-md text-center">
        <div className="flex justify-center mb-4">
          <svg
            className="w-16 h-16 text-green-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Payment ShopSuccessPageful
        </h1>
        <p className="text-gray-600 mb-6">
          Thank you! Your payment has been processed ShopSuccessPagefully.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="/receipt"
            className="px-6 py-3 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 transition duration-200">
            View Receipt
          </a>
          <a
            href="/"
            className="px-6 py-3 bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 transition duration-200">
            Continue Shopping
          </a>
        </div>
        <p className="mt-6 text-xs text-gray-400">
          A receipt has been sent to your email. If you have any questions,
          contact our support team.
        </p>
      </div>
    </div>
  );
};

export default ShopSuccessPage;
